export default __webpack_public_path__ + "static/media/import.bb2546e5.jpg";